import { render, staticRenderFns } from "./ForbiddenKeywordsTableMobile.vue?vue&type=template&id=7bfeb24f&scoped=true"
import script from "./ForbiddenKeywordsTableMobile.vue?vue&type=script&lang=js"
export * from "./ForbiddenKeywordsTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfeb24f",
  null
  
)

export default component.exports